'use es6';

import { createMetricsFactory } from 'metrics-js';

export const Metrics = createMetricsFactory('reference-resolvers');

const tracked = new Set();

const toLabel = (name) => name.replace(/\d+/g, '#').replace(/(_#)+/g, '_#');

export const trackResolverUse = (name, operation) => {
  const resolver = toLabel(name);
  const key = `${resolver}.${operation}`;
  if (tracked.has(key)) {
    return;
  }
  tracked.add(key);
  Metrics.counter('resolver-used', { resolver, operation }).increment();
};
